export function toId(thing) {
    return typeof thing === 'string' ? thing : thing.id;
}
//# sourceMappingURL=toId.js.map